export function appendSearchParams(path: string, params: Record<string, any>) {
  const url = new URL(path)
  const existingParams = searchStringToObject(url.search)

  url.search = objectToSearchString({ ...existingParams, ...params })

  return url.toString()
}

interface EncodedQuery {
  [key: string]: string | (string | null)[] | null | undefined
}

export function objectToSearchString(encodedParams: EncodedQuery): string {
  const params = new URLSearchParams()
  const entries = Object.entries(encodedParams)

  for (const [key, value] of entries) {
    if (value === undefined) continue
    if (value === null) continue

    if (Array.isArray(value)) {
      for (const item of value) {
        params.append(key, item ?? '')
      }
    } else {
      params.append(key, value)
    }
  }

  return params.toString()
}

function searchStringToObject(searchString: string): EncodedQuery {
  const params = new URLSearchParams(searchString)
  const parsed: EncodedQuery = {}
  for (const [key, value] of params) {
    const current = parsed[key]
    if (current !== undefined) {
      if (Array.isArray(current)) {
        current.push(value)
      } else {
        parsed[key] = [current, value]
      }
    } else {
      parsed[key] = value
    }
  }

  return parsed
}
